var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.52 13.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.55,0a4.07,4.07,0,0,1,2.84,1.09A4.07,4.07,0,0,1,13.48,4c0,.72,0,.95,0,2.79s0,2.07,0,2.79a4.07,4.07,0,0,1-1.09,2.84,4.07,4.07,0,0,1-2.84,1.09c-.72,0-1,0-2.79,0s-2.07,0-2.79,0a4.07,4.07,0,0,1-2.84-1.09A4.07,4.07,0,0,1,0,9.55c0-.72,0-1,0-2.79S0,4.69,0,4A4.07,4.07,0,0,1,1.13,1.13,4.07,4.07,0,0,1,4,0c.72,0,.95,0,2.79,0S8.83,0,9.55,0ZM6.76,1.22c-1.8,0-2,0-2.73,0A2.89,2.89,0,0,0,2,2a2.89,2.89,0,0,0-.74,2c0,.71,0,.92,0,2.73s0,2,0,2.73a2.85,2.85,0,0,0,.74,2,2.85,2.85,0,0,0,2,.74c.71,0,.92,0,2.73,0s2,0,2.73,0a2.85,2.85,0,0,0,2-.74,2.87,2.87,0,0,0,.74-2c0-.71,0-.92,0-2.73s0-2,0-2.73a2.89,2.89,0,0,0-.74-2,2.89,2.89,0,0,0-2-.73C8.78,1.22,8.57,1.22,6.76,1.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76,9a2.25,2.25,0,1,1-.09-4.5h.09a2.25,2.25,0,0,1,0,4.5Zm0-5.72a3.47,3.47,0,1,0,3.47,3.47A3.47,3.47,0,0,0,6.76,3.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56,3.15a.81.81,0,1,1,.81.81A.81.81,0,0,1,9.56,3.15Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8a593450d31572c7301addbde3dfbf7a.svg";
export { ForwardRef as ReactComponent };